import { createRouter, createWebHistory } from "vue-router";
import { useCounterStore } from "@/stores/counter";

import { setLocalStor, detectDeviceType, isWeixin } from "../util/index.js";
import Home from "../views/HomeView.vue";

const router = createRouter({
  history: createWebHistory("/community"),
  routes: [
    {
      path: "/",
      name: "cardHome",
      component: Home,
      meta: {
        title: "社区卡盒首页",
        login: false,
      },
    },
    // {
    //   path: "/discover",
    //   name: "discover",
    //   component: () => import("@/views/discover/discover.vue"),
    //   meta: {
    //     title: "发现页",
    //     login: false,
    //     searchType: "discover",
    //   },
    // },
    // {
    //   path: "/discover-info",
    //   name: "discoverInfo",
    //   component: () => import("@/views/discover/discoverInfo.vue"),
    //   meta: {
    //     title: "发现页详情",
    //     login: false,
    //     searchType: "discover",
    //   },
    // },
    {
      path: "/creative-submission",
      name: "creativeSubmission",
      component: () => import("@/views/submission/creativeSubmission.vue"),
      meta: {
        title: "创作投稿",
        login: true,
      },
    },
    {
      path: "/submission-success",
      name: "submissionSuccess",
      component: () => import("@/views/submission/submissionSuccess.vue"),
      meta: {
        title: "投稿成功",
        login: true,
      },
    },
    {
      path: "/user",
      name: "user",
      component: () => import("@/views/user/userView.vue"),
      meta: {
        title: "用户中心",
        login: false,
      },
      children: [
        {
          path: "submission-manage",
          name: "submissionManage",
          component: () => import("@/views/user/manage/submissionManage.vue"),
          meta: {
            title: "投稿管理",
            login: true,
          },
        },
        {
          path: "card-manage",
          name: "cardManage",
          component: () => import("@/views/user/manage/cardManage.vue"),
          meta: {
            title: "卡片管理",
            login: true,
            searchType: "discover",
          },
        },
        {
          path: "earning-manage",
          name: "earningManage",
          component: () => import("@/views/user/manage/earningManage.vue"),
          meta: {
            title: "收益管理",
            login: true,
          },
        },
        {
          path: "orders-manage",
          name: "ordersManage",
          component: () => import("@/views/user/manage/ordersManage.vue"),
          meta: {
            title: "订单管理",
            login: true,
          },
        },
        {
          path: "user-center",
          name: "userCenter",
          component: () => import("@/views/user/center/userCenter.vue"),
          meta: {
            title: "个人中心",
            login: false,
          },
        },
        {
          path: "follow-fans",
          name: "followFans",
          component: () => import("@/views/user/center/followFans.vue"),
          meta: {
            title: "关注与粉丝",
            login: false,
          },
        },
      ],
    },
    {
      path: "/file-preview",
      name: "filePreview",
      component: () => import("@/views/filePreview/filePreview.vue"),
      meta: {
        title: "文件预览",
        login: false,
      },
    },
    {
      path: "/search",
      name: "searchView",
      component: () => import("@/views/search/searchView.vue"),
      meta: {
        title: "搜索",
        login: false,
      },
    },
    {
      path: "/audio-player",
      name: "audioPlayer",
      component: () => import("@/views/audio/audioPlay.vue"),
      meta: {
        title: "音频播放器",
        login: false,
      },
    },
    {
      path: "/small-class",
      name: "smallClass",
      component: () => import("@/views/class/smallClass.vue"),
      meta: {
        title: "小班级",
        login: false,
        searchType: "class",
      },
    },
    {
      path: "/class-info",
      name: "classInfo",
      component: () => import("@/views/class/classInfo.vue"),
      meta: {
        title: "班级详情页面",
        login: false,
        searchType: "class",
      },
    },
    {
      path: "/:pathMatch(.*)*",
      redirect: "/",
    },
  ],
});

router.beforeEach((to, from, next) => {
  const store = useCounterStore();
  if (to.name == "filePreview" && detectDeviceType() && isWeixin()) {
    let url =
      import.meta.env.VITE_WXSHARE_URL +
      `/com-file-preview?fileType=${to.query.fileType}&fileId=${to.query.fileId}`;
    window.location.replace(url);
    return;
  }
  //第一次登录
  if (to.query.token) {
    let token = decodeURIComponent(to.query.token);
    setLocalStor("userMessage", {
      token: token,
    });
    let obj = JSON.parse(JSON.stringify(to.query));
    delete obj.token;
    store
      .getUserMessage()
      .then(() => {
        next({ path: to.path, query: obj });
      })
      .catch(() => {
        next({ path: "/" });
      });
    return;
  }
  if (store.user) {
    next();
  } else {
    store
      .getUserMessage()
      .then(() => {
        next();
      })
      .catch((title) => {
        let loginUrl = import.meta.env.VITE_LOGIN_URL;
        let currentUrl = window.location.href;
        switch (title) {
          case "登录失效":
            window.location.replace(
              `${loginUrl}?source=` + encodeURIComponent(currentUrl)
            );
            break;
          case "未登录":
            // 需要登录可访问的页面
            if (to.meta.login) {
              // window.location.replace(
              //   `${loginUrl}?source=` + encodeURIComponent(currentUrl)
              // );
              next({ path: "/" });
            } else next();
            break;
          default:
            next({ path: "/" });
            break;
        }
      });
  }
});
export default router;
